import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { User } from '../../core/models/user.model';
import { UserService } from '../../core/services/user.service';
import { AuthService } from '../../core/services/auth.service';

import { Meta, Title } from '@angular/platform-browser';
import { DesignService } from '../../core/services/design.service';
import { LoaderService } from '../../core/loader.service';
import { ProfileService } from '../../core/services/profile.service';
import { ClarityService } from '../../core/services/clarity.service';

declare var clarity: any;
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit {
  // user
  user: User = new User();
  navigation: any;
  // flag denoting invalid login i.e wrong email or password.
  invalidLogin: boolean = false;
  loading = false;
  representativeList: Array<String> = [];
  clarity: any;
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private designService: DesignService,
    private title: Title,
    private meta: Meta,
    private loaderService: LoaderService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private clarityService: ClarityService
  ) {
    this.designService.setHeaderStyle('auth'); // Set Header Style to auth
    this.navigation = this.router.getCurrentNavigation(); // Get Current URL

    const user = this.authService.getUser(); // Get user from session
    if (user !== null) {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'];
      if (user.roleProtectedObjectList[0].roleId === 1) {
        // If the logged in user is admin
        this.router.navigate(['/category']); // navigate to category
      } else if (user.roleProtectedObjectList[0].roleId === 2) {
        // If the logged in user is not admin
        if (user.verified === false || user.verified === null) {
          // user is not verified.
          if (returnUrl) {
            this.router.navigate(['/signup'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.router.navigate(['/homepage']); // navigate to homepage
          }
        } else if (user.verified === true) {
          // user is verified.
          if (
            (user.defaultProfileId === false &&
              user.reviewProfileId == false) ||
            user.verified === null
          ) {
            this.router.navigate(['/signup'], {
              queryParamsHandling: 'preserve',
            });
          } else if (
            user.defaultProfileId !== null ||
            user.reviewProfileId != null
          ) {
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else {
              this.router.navigate(['/homepage']); // navigate to homepage
            }
          }
        }
      }
    }
    this.title.setTitle('CitizeX');
    let description =
      'CitizeX is social networking service based on United states politicians where all levels of government politicians can interact with message known as "Post a Review." Verified politicians can give review and response, but unregistered politicians can only read them.';
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.removeTag('name= "keywords"');
  }
  ngOnInit() {}

  // takes the login credentials as input and passes it to service method.
  // used for logging in to the account
  validateLogin(signinForm: NgForm) {
    if (signinForm.invalid) {
      return;
    }
    this.loading = true;
    this.user.userName = signinForm.form.value.userName.trim().toLowerCase();
    this.user.email = signinForm.form.value.userName.trim().toLowerCase();
    this.user.password = signinForm.form.value.password;

    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.userService
      .login(this.user, signinForm.form.value.remMe === true)
      .subscribe(
        async (success) => {
          /* if (success.success === 1) {
          this.invalidLogin = true;
        } else */
          if (success.success === 0) {
            if (success.data) {
              this.normalizeEmailPreferences(success.data);
            }
            if (
              !this.authService.startSession(
                success,
                signinForm.form.value.remMe === true
              )
            ) {
              this.invalidLogin = true;
              this.loading = false;
              return;
            }
            this.invalidLogin = false;
            this.loading = false;
            await this.clarityService.trackUser({
              userId: success.data.userId,
              email: success.data.email,
              phoneNumber: success.data.phoneNumber,
            });
            if (success.data.address != null) {
              this.getRepresentative(success.data.address);
            }
            if (success.data.roleProtectedObjectList[0].roleId === 1) {
              // If the logged in user is admin
              this.router.navigate(['/category']);
            } else if (success.data.roleProtectedObjectList[0].roleId === 2) {
              // If the logged in user is not admin
              if (
                success.data.verified === false ||
                success.data.verified === null
              ) {
                // user is not verified.
                this.router.navigate(['/signup'], {
                  queryParamsHandling: 'preserve',
                });
              } else if (success.data.verified === true) {
                // user is verified.
                if (
                  success.data.defaultProfileId === null &&
                  success.data.reviewProfileId == null
                ) {
                  // this.router.navigate(['/profile/search-profile']);
                  this.router.navigate(['/signup'], {
                    queryParamsHandling: 'preserve',
                  });
                } else if (
                  success.data.defaultProfileId !== null ||
                  success.data.reviewProfileId != null
                ) {
                  // ✅ Redirect to returnUrl if available
                  if (returnUrl) {
                    this.router.navigateByUrl(returnUrl);
                  } else {
                    this.router.navigate(['/homepage']);
                  }
                }
              }
            }
          } else {
            this.invalidLogin = true;
            this.loading = false;
          }
        },
        (error) => {
          this.invalidLogin = true;
          this.loading = false;
        }
      );
  }

  private normalizeEmailPreferences(userData: any): void {
    if (
      userData.isEmailNotified !== undefined &&
      userData.isEmailNotified !== null
    ) {
      userData.isEmailNotified = Boolean(userData.isEmailNotified);
      userData.isUnsubscribed = !userData.isEmailNotified;
      return;
    }

    if (
      userData.isUnsubscribed !== undefined &&
      userData.isUnsubscribed !== null
    ) {
      userData.isUnsubscribed = Boolean(userData.isUnsubscribed);
      userData.isEmailNotified = !userData.isUnsubscribed;
    }
  }

  // For fetching representative list according to address
  getRepresentative(address: string) {
    address = address.replace(/\n/g, ' '); // Replaces \n with a space
    this.loaderService.disable = true;

    this.profileService.getReprentatives(address).subscribe((res) => {
      if (res.success === 0) {
        res.data.forEach((obj: any) => {
          this.representativeList.push(obj.tagname);
        });
        this.authService.setRepresentativeList(this.representativeList);
      }
    });
  }
}
